import React from 'react'
import { Link } from 'react-router-dom'
export default function Footer() {
    return (
        <div>
            <footer class="site-footer">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3 col-12">
                            <h6>About Company</h6>
                            <p class="text-justify">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam a optio dolorum inventore assumenda rem voluptas minima itaque obcaecati sunt doloribus quis quos, quas numquam amet reiciendis unde, quisquam aliquam!</p>
                        </div>

                        <div class="col-md-3 col-12">
                            <h6>Company</h6>
                            <ul class="footer-links" style={{ textDecoration: 'none' }}>
                                <div className="row">
                                    <div className="col-6">
                                        <Link to="/"><li><a className='py-5' style={{ textDecoration: 'none' }}>Home</a></li></Link>
                                        <Link to="/services"><li><a className='py-5' style={{ textDecoration: 'none' }}>Services</a></li></Link>
                                        <Link to="/contactus"><li><a className='py-5' style={{ textDecoration: 'none' }}>Contact Us</a></li></Link>
                                    </div>
                                    <div className="col-6">

                                        <Link to="/contactus"><li><a className='py-5' style={{ textDecoration: 'none' }}>Who We Are</a></li></Link>
                                        <Link to="/contactus"><li><a className='py-5' style={{ textDecoration: 'none' }}>Features</a></li></Link>
                                        <Link to="/contactus"><li><a className='py-5' style={{ textDecoration: 'none' }}>Our Work</a></li></Link>
                                    </div>
                                </div>


                            </ul>
                        </div>
                        <div class="col-md-3 col-12">
                            <h6 className='mx-2'>CONSTRUCTION OFFICE</h6>
                            <ul class="footer-links">
                                <div className="d-flex my-2">
                                    <i class="fa fa-map-marker p-2 m-2" aria-hidden="true"></i>
                                    <p>499 Hwy 71w suite 200 bastrop TX 78602</p>
                                </div>
                                <div className="d-flex my-2">
                                    <i class="fa fa-phone p-2 m-2" aria-hidden="true"></i>
                                    <p>512 923 9756</p>
                                </div>
                                <div className="d-flex my-2">
                                    <i class="fa fa-envelope p-2 m-2" aria-hidden="true"></i>
                                    <p className='my-2'>Info@moabbuilders.com</p>
                                </div>
                            </ul>
                        </div>

                        <div class="col-md-3 col-12">
                            <h6 className='mx-1'>BUSINESS HOURS</h6>
                            <ul class="footer-links">
                                <p className='mx-1'>Our support available to help you 24 hours a day, seven days a week.</p>
                            </ul>
                            <div className="mx-1">
                                <div className="d-flex justify-content-between">
                                    <p>Monday-Friday:</p>
                                    <p style={{fontSize:'12px'}}>8:00am to 6:00pm</p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p>Saturday</p>
                                    <p style={{fontSize:'12px'}}>Closed</p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p>Sunday</p>
                                    <p style={{fontSize:'12px'}}>Closed</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 col-sm-6 col-xs-12">
                            <p class="copyright-text">Copyright &copy; 2023 All Rights Reserved by
                                <a style={{ textDecoration: 'none' }}>MOAB</a>.
                            </p>
                            <p class="copyright-text">Site Owned by: MOAB Construction

                            </p>
                            <p style={{fontSize:'10px'}} class="copyright-text">Site Developed by: Ashar Ahmed

                            </p>
                        </div>

                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <ul class="social-icons">
                           <li><a class="facebook" target="blank"><i class="fa fa-facebook"></i></a></li>
                          <li><a class="twitter"><i class="fa fa-twitter"></i></a></li>
                           <li><a class="dribbble"><i class="fa fa-dribbble"></i></a></li>
                          <li><a class="linkedin"><i class="fa fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/footer.jsx